<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else class="m-20-auto center">

        <div class="wrapper-photo">
            <div class="container-photo">
                <img :src="src" alt="">
            </div>
        </div>
     
        <b-container class="container-edit-gallery-info">
            <b-list-group style="width: 100%">

                <b-list-group-item>
                   
                    <custom-multiselect v-model="entity.Category" 
                                        :options="photoCategories" 
                                        :preselect-first="true"
                                        :disabled="entity.IsReadOnlyCategory"
                                        track-by="Id"
                                        label="Name"
                                        class="mb-20"
                                        placeholder="Выберите категорию фото"
                                        @select="selectCategory"/>
                
                    <b-form-textarea v-model="entity.Comment"
                                    placeholder="Комментарий"
                                    rows="2"/>                

                </b-list-group-item>

                <b-list-group-item style="background: #FAFAFA" >

                    <b-row class="m-0">

                        <b-col class="p-0">
                            <b-button variant="outline-danger"
                                      class="button-red"
                                      :disabled="!entity.Url"
                                      @click="deletePhotoDialog">
                                Удалить
                            </b-button>
                        </b-col>

                        <b-col class="p-0 h-end">
                            <b-button variant="outline-primary" 
                                      class="button-blue"
                                      @click="savePhoto">
                                Сохранить
                            </b-button>
                        </b-col>

                    </b-row>

                </b-list-group-item>
            </b-list-group>
        </b-container>

    </b-container> 

</template>

<script>
import '@/assets/styles/client/gallery/galleryEdit.css'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import AllRoutes from '@/routes/all.routes'

import PhotoGalleriesModel from '@/store/models/client/gallery/PhotoGalleries'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'

export default {
    computed: {
        src: function() {
            return this.entity.Url ? this.entity.Url : this.photo.Data
        }
    },
    data: function() {
        let load = new Loading();

        let id = this.$route.query.id ? this.$route.query.id : null;

        let entity;

        if(id)
            entity = {};            
        else
            entity = new PhotoGalleriesModel();

        this.getCategories(load);

        return {
            id: id,
            entity: entity,

            load: load,
            photoCategories: [],

            photo: {},

            auditId: this.$route.query.auditId,
            formId: this.$route.query.formId
        }
    },
    watch: {
        photo: {
            handler: function() {
                this.updateStorage();
            },
            deep: true
        },
        entity: {
            handler: function() {
                this.updateStorage();
            },
            deep: true
        }
    },
    created: function() {                
        if(Object.keys(this.$route.params).length) {
            this.updateStorage();
        }

        let storedPhoto = this.getStorage();

        if(this.$route.query.id)
            this.entity = { ...this.$route.params.photo, ...storedPhoto }; 
        else
            this.photo = { ...this.$route.params.photo, ...storedPhoto }; 
    },
    methods: {
        getStorage: function() {
            return JSON.parse(localStorage.getItem('Photo'));
        },
        setStorage: function(value) {
            localStorage.setItem('Photo', JSON.stringify(value));
        },
        updateStorage: function() {
            let storedPhoto = this.getStorage();

            if(!storedPhoto) storedPhoto = {};

            if(this.$route.query.id)
                storedPhoto = JSON.parse(JSON.stringify(this.entity));
            else
                storedPhoto = JSON.parse(JSON.stringify(this.photo));

            this.setStorage(storedPhoto);
        },

        getCategories: function(load) {
            load.Calculate(false);

            apiService.Client.Photos.GetCategories()
                .then(response => {
                    this.photoCategories = response.data;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },
        selectCategory: function(value) {
            if(!this.id)
                this.photo.CategoryId = value.Id;  
        },

        savePhoto: function() {
            if(this.id) {
                this.savePhotoGalleries();
                return;
            }

            if(!this.entity.isValid()) {
                dialogService.showAlert('Предупреждение', 'Выберите категорию');
                return;
            }

            this.load.Calculate(true);

            let photoDto = JSON.parse(JSON.stringify(this.photo));

            apiService.Client.Photos.PostUpdate(photoDto)
                .then(response => {
                    this.load.Calculate(false);
                    this.savePhotoGalleries(response.data);
                })
                .catch(error => this.load.Calculate(false));

        },
        savePhotoGalleries: function(url) {
            this.load.Calculate(true);
            let photoGalleriesDto = JSON.parse(JSON.stringify(this.entity));

            if(!this.id)
                photoGalleriesDto = this.entity.mapToDto(url);

            apiService.Client.Gallery.PostUpdate(this.auditId, this.formId, photoGalleriesDto)
                .then(response => {
                    this.$router.push(AllRoutes.Client.Gallery.Index + `?auditId=${this.auditId}&formId=${this.formId}`);
                })
                .catch(error => this.load.Calculate(false));

        },

        deletePhotoDialog: function() {
            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данную фотографию?')
                .then(ok => {
                    this.deletePhoto();
                })
                .catch(cancel => {});
        },
        deletePhoto: function() {
            this.load.Calculate(true);

            apiService.Client.Gallery.PostDelete(this.auditId, this.formId, this.id)
                .then(response => {
                    this.$router.push(AllRoutes.Client.Gallery.Index + `?auditId=${this.auditId}&formId=${this.formId}`);
                })
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        CustomMultiselect
    }

}
</script>